/*
 * keyPath: where to retrieve the value when sending to a component
 *              (some components receive a simple value, then return an object of data,
 *              in which case we need to save data differently than how we send it)
 * */
export default (t) => {
  return {
    compact: [
      {
        detailFields: {
          country: {
            keyPath: ['country', 'country_code'],
            title: t('Country'),
            type: 'dropdown',
            optionsKey: 'countries'
          },
          created: {
            keyPath: ['created_at'],
            title: t('Created')
          },
          updated: {
            keyPath: ['updated_at'],
            title: t('Last Updated')
          }
        },
        tableFields: [
          {
            keyPath: ['native_name'],
            title: t('Name'),
            isLocalized: true
          },
          {
            keyPath: ['group_code'],
            title: t('Code')
          },
          {
            keyPath: ['active'],
            title: t('Active'),
            type: 'status'
          },
          {
            keyPath: ['parent', 'name'],
            title: t('Parent Group'),
            validationKey: 'parent_id'
          }
        ]
      }
    ]
  };
};

export const translationFields = ['name', 'data'];

//key: key of request object
//keyPath: where to retrieve the value, that will be set to the key
export const updateFields = [
  {
    key: 'group_code',
    keyPath: ['group_code']
  },
  {
    key: 'name',
    keyPath: ['name']
  },
  {
    key: 'active',
    keyPath: ['active']
  },
  {
    key: 'country',
    keyPath: ['country', 'country_code']
  },
  {
    key: 'parent_id',
    keyPath: ['parent', 'id']
  },
  {
    key: 'products',
    keyPath: ['products', 'value']
  }
];

export const tableHeaders = (t) => {
  return [
    {
      key: 'number',
      name: ' '
    },
    {
      key: 'name',
      name: t('Name')
    },
    {
      key: 'code',
      name: t('Code')
    },
    {
      key: 'active',
      name: t('Active'),
      tooltipText: t('Users in a deactivated group can no longer login.')
    },
    {
      key: 'parent_group',
      name: t('Parent Group'),
      tooltipText: t(
        'Every user group is associated with a Parent Group. All groups are related to each other and function similarly to a family tree.'
      )
    },
    {
      key: 'edit',
      name: ' '
    }
  ];
};



// WEBPACK FOOTER //
// ./src/conf/userGroupFields.js